import { lazyWithRetry } from "utils/lazy-with-retry";
import { ICreateEditEscalationTemplateProps } from "./definitions";

const LazyCreateEditEscalationTemplate = lazyWithRetry(
  () => import("./CreateEditEscalationTemplate"),
);

const CreateEditEscalationTemplate = (
  props: JSX.IntrinsicAttributes & ICreateEditEscalationTemplateProps,
) => <LazyCreateEditEscalationTemplate {...props} />;

export default CreateEditEscalationTemplate;
